export default __webpack_public_path__ + "static/media/real.955b5ca2.svg";